import React from "react";
import {formatDateSeconds, numberWithCommas} from "../../Helpers/Utils/Common";
import "./Print.css";


//logo image
import "./Print.css"
export class CashCountPrint extends React.PureComponent{
    
    render() {
    
        const marginTop = "-1000px";
        const marginRight = "60px";
        const marginBottom = "-1000px";
        const marginLeft = "50px";
        const getPageMargins = () => {
            return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
        };

        return (
        <div className="S">
            <style>{getPageMargins()}</style>
            <div className="print-area rounded p-4 single-width">
                <div className="row mt-1">
                    <div className="d-flex col-6 justify-content-left col-6">
                    <label className="mb-1 print-text">
                        Cash Count
                    </label>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        <label className=" mb-1 print-text cashcount-text-bold">
                            <strong>{this.props.cashier}</strong>
                        </label>
                    </div>
                </div>
                <div className="d-flex row justify-content-left mt-1">
                    <label className="d-flex row justify-content-left mb-1 print-text">
                        {formatDateSeconds(new Date())}
                    </label>
                </div> 
                <hr/>
                <div className="d-flex row justify-content-center mt-3">
                    <label className="d-flex row justify-content-center mb-1 print-text cashcount-text-bold">
                        CASH REMITTED
                    </label>
                </div>
                <div className="d-flex row justify-content-center mb-1">
                    <div className="col-4">
                        <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                        Denomination
                        </label>
                    </div>
                    <div className="col-4">
                        <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                        Qty
                        </label>
                    </div>
                    <div className="col-4 text-right align-right">
                        <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                        Amount
                        </label>
                    </div>
                </div>
                {this.props.billCount.map((data)=> 
                <div className="d-flex row justify-content-center mb-1">
                    <div className="col-4">
                        <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                        {data.bill}
                        </label>
                    </div>
                    <div className="col-4">
                        <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                        {data.qty}
                        </label>
                    </div>
                    <div className="col-4 text-right align-right">
                        <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                        {numberWithCommas(parseFloat(data.total).toFixed(2))}
                        </label>
                    </div>
                </div>
                )}
                <div className="d-flex row justify-content-center mb-1">
                    <div className="col-4">
                        <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                            Coins
                        </label>
                    </div>
                    <div className="col-4">
                        <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                            {this.props.coinRemittd}
                        </label>
                    </div>
                    <div className="col-4 text-right align-right">
                        <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                        <strong>{numberWithCommas(parseFloat(this.props.coinRemittd).toFixed(2))}</strong>
                        </label>
                    </div>
                </div>
                <hr/>
                {/* <div className="dotted-line"></div> */}
                <div className="d-flex row justify-content-center mb-1">
                    <div className="col-4">
                        <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                            
                        </label>
                    </div>
                    <div className="col-4">
                        <label className="d-flex row justify-content-center ms-0 mb-1 print-text cashcount-text-bold">
                            TOTAL:
                        </label>
                    </div>
                    <div className="col-4 text-right align-right">
                        <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                            <strong>{numberWithCommas(parseFloat(this.props.totalRemit).toFixed(2))}</strong>
                        </label>
                    </div>
                </div>
            </div>
        </div>
      );
    }
}

export default CashCountPrint;
